/**
 * workflowTypeLabel
 * Shared mapping from a stored `workflowType` key (e.g. "red_dot") to its
 * user-facing label (e.g. "Red Dot"). Any control rendering a raw workflow
 * type to a user (badges, filter dropdowns, form option lists) should use
 * this instead of rendering the key directly.
 *
 * ADO #570: the My Tasks workflow filter was rendering the raw key.
 */

export function workflowTypeLabel(workflowType: string): string {
  const normalized = workflowType.toLowerCase().replace(/[-_\s]/g, '');

  if (normalized === 'reddot') {
    return 'Red Dot';
  }

  if (normalized === 'qualitysurvey' || normalized === 'survey') {
    return 'Survey';
  }

  if (normalized === 'ceu') {
    return 'CEU';
  }

  // Fallback: capitalize each word, e.g. "preference_assessment" -> "Preference Assessment"
  return workflowType
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
